/* eslint-disable no-param-reassign */
import {
  call,
  put,
  select,
  CallEffect,
  PutEffect,
  SelectEffect,
} from 'redux-saga/effects';
import { PayloadAction, AnyAction } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';

import { buildApiUrl } from 'environment';
import fetchHelper from 'services/apiService';
import type { HttpResponse } from 'services/apiService';
import {
  createErrorId,
  createBackendErrorMessage,
  createNetworkErrorMessage,
} from 'services/errorService';
import type { StatusCounts } from 'state/shared/createStatusCounts';

import { signUpStepsActions } from '../signUpStepsSlice';
import { selectCurrentStep } from '../signUpStepsSelectors';
import type { AccountDetailsDto } from '../signUpStepsTypes';

const { ACCOUNT_DETAILS_SUCCESS, ACCOUNT_DETAILS_FAILURE, UPDATE_STEP } =
  signUpStepsActions;

export default function* accountDetails(
  statusCounts: StatusCounts,
  action: PayloadAction<AccountDetailsDto>
): Generator<
  CallEffect<AnyAction> | PutEffect<AnyAction> | SelectEffect,
  void,
  HttpResponse & number
> {
  const {
    payload: { username, firstName, lastName, phoneNumber, country }, // TODO: probably no need to destructure, just send payload in yield call
  } = action;
  const { type: errorActionType } = ACCOUNT_DETAILS_FAILURE;
  try {
    const response = yield call(
      fetchHelper.post,
      buildApiUrl('accountDetails'),
      { username, firstName, lastName, phoneNumber, country }
    );
    if (response.ok) {
      yield put(ACCOUNT_DETAILS_SUCCESS());
      const currentStep: number = yield select(selectCurrentStep);
      yield put(UPDATE_STEP(currentStep + 1));
      // TODO: Figure out what final behavior should be, right now it redirects to sign in page
      yield put(push('/signIn'));
    } else if (response) {
      // backend error
      yield put(
        ACCOUNT_DETAILS_FAILURE({
          id: createErrorId(
            errorActionType,
            (statusCounts[errorActionType] += 1)
          ),
          error: createBackendErrorMessage(response),
        })
      );
    }
  } catch (error) {
    // network error
    if (error instanceof Error) {
      yield put(
        ACCOUNT_DETAILS_FAILURE({
          id: createErrorId(
            errorActionType,
            (statusCounts[errorActionType] += 1)
          ),
          error: createNetworkErrorMessage(error),
        })
      );
    }
  }
}
